import PlanCuentasCard from "./PlanCuentasCard";
export default PlanCuentasCard;